import React from 'react';
import {obterContratosSemInclude,transferirContrato} from '../actions/ContratoActions';
import {obterUsuariosAdministracao} from '../actions/UsuarioActions';
import {connect} from 'react-redux';
import {enviarEmail} from '../actions/EmailActions';
import {cadastrarAcao} from '../actions/AcaoActions';
import { toast } from 'react-toastify';

class ContratosTransferencia extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      contratos:[],
      usuarios:[]
    }
  }

  componentWillMount(){
    this.props.obterContratosSemInclude();
    this.props.obterUsuariosAdministracao();
  }

  componentDidMount(){
    window.iniciarSelect();
  }

  transferir(){
    let contratoId = parseFloat(this.refs.selectContrato.value),
      usuarioId = parseFloat(this.refs.selectUsuario.value),
      usuarioEmail = this.props.usuarios.filter((u) => usuarioId === u.id ? u.email : false)[0].email,
      fields = {
        dono: usuarioId
      };
    this.props.transferirContrato(fields, contratoId).then(()=>{
      toast.success("Contrato transferido com sucesso!");
      toast.info("Aguarde enquanto o e-mail é enviado");
      let acao ={
        ator:usuarioId ,
        texto:"O contrato " + this.props.contratos.filter((c)=>{return c.id === contratoId})[0].numero + " foi tranferido para o usuario "+ this.props.usuarios.filter((u)=>{ return u.id === usuarioId})[0].nome,
        data:new Date(),
        contrato:contratoId,
        tipo:"notificacao",
        visualizado:false
      };
      let email = {
        destinatario: usuarioEmail,
        corpo: "O contrato " + this.props.contratos.filter((c)=>{return c.id === contratoId})[0].numero + " foi transferido para você!", 
        assunto: "Transferência de contrato - " + this.props.contratos.filter((c)=>{return c.id === contratoId})[0].numero
      };
      this.props.cadastrarAcao(acao);
      this.props.enviarEmail(email);
    });
  }

  getContrato(contratoId){
    let contrato = this.props.contratos.filter((contrato) => {
      return contrato.id===parseFloat(contratoId);
    });
    return contrato[0];
  }

  render(){
    return(
      <div>
        <div className="box">
          <div className="box-body">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="produto">Selecione o contrato</label>
                <select name="produto" ref="selectContrato" className="form-control select2" style={{width: "100%"}}>
                  {
                    this.props.contratos.map((contrato) => (
                      <option value={contrato.id} key={"c" + contrato.id}>{contrato.numero} - {contrato.emailComissao}</option>
                    ))
                  }
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="produto">Selecione o usuário para transferir</label>
                <select name="produto" ref="selectUsuario" className="form-control select2" style={{width: "100%"}}>
                  {
                    this.props.usuarios.map((usuario) => (
                      <option value={usuario.id} refs={usuario.email} key={"u" + usuario.id}>{usuario.nome}</option>
                    ))
                  }
                </select>
              </div>
            </div>
          </div>

          <div className="box-footer">
            <input type="button" onClick={this.transferir.bind(this)} className="btn  btn-primary flat pull-right" value="Tranferir" />
            <i className="fa fa-fw fa-2x fa-spinner fa-spin pull-right" style={this.props.carregando ? {display: ""} : {display: "none"}}></i>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contratos: state.contrato.todos,
    usuarios:state.usuario.todos,
    carregando: state.contrato.carregando
  }
}

export default connect(mapStateToProps, {cadastrarAcao, obterContratosSemInclude,obterUsuariosAdministracao,transferirContrato, enviarEmail})(ContratosTransferencia);



// WEBPACK FOOTER //
// ./src/views/ContratosTransferencia.js